export function someFromIndex<T>(
  array: T[],
  startIndex: number,
  predicate: (item: T, index: number) => boolean
): boolean {
  for (let i = startIndex; i < array.length; i++) {
    if (predicate(array[i], i)) {
      return true;
    }
  }
  return false;
}

export function countAndCheckFollowingItems<
  T extends Record<string, any>,
  K extends keyof T,
  P extends keyof T
>(
  array: T[],
  startIndex: number,
  propertyName: K,
  expectedValue: any, // attendu dans l'array
  flagProperty: P
): { count: number; hasFlag: boolean } {
  let count = 0;
  let hasFlag = false;

  for (let i = startIndex + 1; i < array.length; i++) {
    const item = array[i];
    const prop = item[propertyName];

    // Vérifie que la propriété est bien un tableau et qu'elle contient expectedValue
    if (!Array.isArray(prop) || !prop.includes(expectedValue)) {
      break;
    }

    // Incrémenter le compteur
    count++;

    // Vérifie la présence du flag (ex: idEntitySaved)
    if (flagProperty in item && item[flagProperty] != null) {
      hasFlag = true;
    }
  }

  return { count, hasFlag };
}
